
import { Fragment, SyntheticEvent, useEffect, useState } from 'react'
import { useGetAllWidgetsQuery } from '../../../../../../redux/slices/widget/apiWidgetSlice'
import { CardWidget } from '../../../../../content/components/cards/CardWidget'



const TabWidget = () => {
  const { data: allWidgets, isLoading: isLoadingWidget } = useGetAllWidgetsQuery(5, { refetchOnMountOrArgChange: true })  
  console.log("allWidgets: ", allWidgets);

  // -------------------------------
  return (
    <div className="d-flex flex-column flex-row-auto w-100 vh-100 bg-gray-300">
        <div className="d-flex flex-column-auto h-70px bg-gradient-primary" 
          style={{
            paddingTop:"2px", 
            // backgroundImage: "linear-gradient(#F04E5D, #9C258F)"
          }}
        >
          {/* Tab Menu */}
          <div className='w-100 mt-8 ms-0 me-0 pt-0 '>         
          
          </div>
        </div>
        
        <div className='container mt-8 ms-0 me-0 pt-0 '>
        <div className="row px-0 gy-1">
                  { !isLoadingWidget && allWidgets && allWidgets.length > 0 &&                                 
                    <>          
                      { allWidgets
                        .slice().sort((a,b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1: -1)
                        .map((widget, ind) => {
                          // --------------------------
                          return ( 
                            <Fragment key={widget.id}>
                               <CardWidget
                               widgetId={`${widget.id}`}
                                 key={widget.id}
                                 className="col-6 col-lg-4 col-xl-4 col-xxl-4" 
                                 widget = {widget}
                                 autoLayout={false}
                                 //active={tmplate.template_id === currContentPersistor.template_id}
                                 // ribbonType = { (moment().diff(moment.utc(content.modified_time).local())/(1000*60*60*24)) <= RECENTPERIOD ? "recent": ""}                                         
                               />
                            </Fragment>
                          )
                        })                        
                      }
                    </>                       
                  }
                </div>
          
        </div>        
    </div>    
    
  )
}

export {TabWidget}
